import { Component, OnInit, Input, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-pos-services-card',
    templateUrl: './pos-services-card.component.html',
    styleUrls: ['./pos-services-card.component.css'],
    standalone: false
})
export class PosServicesCardComponent implements OnInit, OnDestroy {
  @Input() pos_services;
  constructor() { }

  ngOnInit() {
    
  }
  ngOnDestroy() {}

}
